<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <div
      class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-top spacing--padding-half-bottom"
    >
      {{ 'barn.general' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn.name' | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'barn.name' | translate }}"
        formControlName="name"
        data-test="barn-item__name"
      />
      <mat-error
        *ngIf="!!formGroup.controls.name.errors && formGroup.controls.name.errors.duplicateBarnName"
      >
        duplicate
      </mat-error>
      <mat-error
        *ngIf="!!formGroup.controls.name.errors && formGroup.controls.name.errors.required"
        >{{ 'barn.invalid.name' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn.surface-area' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.0001"
        placeholder="{{ 'barn.surface-area' | translate }}"
        formControlName="surfaceArea"
        data-test="barn-item__surface-area"
      />
      <span matTextSuffix class="form-field-suffix">m2</span>
      <mat-error *ngIf="formGroup.controls.surfaceArea.invalid">{{
        'barn.invalid.surface-area' | translate
      }}</mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn.jumping-facilities' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'barn.jumping-facilities' | translate }}"
        formControlName="jumpingFacilities"
        data-test="barn-item__jumping-facilities"
      >
        <mat-option value="ContinuousHopper">{{ 'barn.continuous-hopper' | translate }}</mat-option>
        <mat-option value="LooseTables">{{ 'barn.loose-tables' | translate }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.jumpingFacilities.invalid">
        {{ 'barn.invalid.jumping-facilities' | translate }}</mat-error
      >
    </mat-form-field>

    <div class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-half-bottom">
      {{ 'barn.feed' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn.number-of-feedlines' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.0001"
        placeholder="{{ 'barn.number-of-feedlines' | translate }}"
        formControlName="numberOfFeedLines"
        data-test="barn-item__number-of-feedlines"
      />
      <mat-error *ngIf="formGroup.controls.numberOfFeedLines.invalid">
        {{ 'barn.invalid.number-of-feedlines' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn.method-of-feedadministration' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'barn.method-of-feedadministration' | translate }}"
        formControlName="methodOfFeedAdministration"
        data-test="barn-item__method-of-feedadministration"
      >
        <mat-option value="Pan">{{ 'barn.feeding-pan' | translate }}</mat-option>
        <mat-option value="Chain">{{ 'barn.feeding-chain' | translate }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.methodOfFeedAdministration.invalid">
        {{ 'barn.invalid.method-of-feedadministration' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field
      class="flex__child--auto"
      *ngIf="formGroup.controls.methodOfFeedAdministration.value === 'Chain'"
    >
      <mat-label>{{ 'barn.length-of-feedgutter-in-meters' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'barn.length-of-feedgutter-in-meters' | translate }}"
        formControlName="lengthOfFeedGutterInMeters"
        data-test="barn-item__lengthOfFeedGutterInMeters"
      />
    </mat-form-field>
    <span
      *ngIf="formGroup.errors?.chainValue"
      class="custom-properties-validation spacing--margin-negative-top spacing--margin-half-left spacing--padding-half-bottom"
    >
      {{ 'barn.invalid.length-of-feedgutter-in-meters' | translate }}</span
    >

    <mat-form-field
      class="flex__child--auto"
      *ngIf="formGroup.controls.methodOfFeedAdministration.value === 'Pan'"
    >
      <mat-label>{{ 'barn.number-of-feedpans' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'barn.number-of-feedpans' | translate }}"
        formControlName="numberOfFeedPans"
        data-test="barn-item__numberOfFeedPans"
      />
    </mat-form-field>
    <span
      *ngIf="formGroup.errors?.panValue"
      class="custom-properties-validation spacing--margin-negative-top spacing--margin-half-left spacing--padding-half-bottom"
    >
      {{ 'barn.invalid.number-of-feedpans' | translate }}</span
    >

    <div class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-half-bottom">
      {{ 'barn.water' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn.number-of-waterlines' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'barn.number-of-waterlines' | translate }}"
        formControlName="numberOfWaterLines"
        data-test="barn-item__numberOfWaterLines"
      />
      <mat-error *ngIf="formGroup.controls.numberOfWaterLines.invalid">
        {{ 'barn.invalid.number-of-waterlines' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn.water-supply' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'barn.water-supply' | translate }}"
        formControlName="waterSupply"
        data-test="barn-item__waterSupply"
      >
        <mat-option value="WaterNipples">{{ 'barn.water-nipples' | translate }}</mat-option>
        <mat-option value="DrinkingTowers">{{ 'barn.drinking-towers' | translate }}</mat-option>
        <mat-option value="Both">{{ 'barn.both' | translate }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.waterSupply.invalid">
        {{ 'barn.invalid.water-supply' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field
      class="flex__child--auto"
      *ngIf="
        formGroup.controls.waterSupply.value === 'WaterNipples' ||
        formGroup.controls.waterSupply.value === 'Both'
      "
    >
      <mat-label>{{ 'barn.number-of-waternipples' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'barn.number-of-waternipples' | translate }}"
        formControlName="numberOfWaterNipples"
        data-test="barn-item__numberOfWaterNipples"
      />
    </mat-form-field>
    <span
      *ngIf="formGroup.errors?.waterNipples"
      class="custom-properties-validation spacing--margin-negative-top spacing--margin-half-left spacing--padding-half-bottom"
    >
      {{ 'barn.invalid.number-of-waternipples' | translate }}</span
    >

    <mat-form-field
      class="flex__child--auto"
      *ngIf="
        formGroup.controls.waterSupply.value === 'DrinkingTowers' ||
        formGroup.controls.waterSupply.value === 'Both'
      "
    >
      <mat-label>{{ 'barn.number-of-drinkingtowers' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'barn.number-of-drinkingtowers' | translate }}"
        formControlName="numberOfDrinkingTowers"
        data-test="barn-item__numberOfDrinkingTowers"
      />
    </mat-form-field>
    <span
      *ngIf="formGroup.errors?.drinkingTowers"
      class="custom-properties-validation spacing--margin-negative-top spacing--margin-half-left spacing--padding-half-bottom"
    >
      {{ 'barn.invalid.number-of-drinkingtowers' | translate }}</span
    >

    <div class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-half-bottom">
      {{ 'barn.lighting' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn.lighting' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="lighting"
        formControlName="lighting"
        data-test="barn-item__lighting"
      >
        <mat-option value="tl">{{ 'barn.tl' | translate }}</mat-option>
        <mat-option value="led">{{ 'barn.led' | translate }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.lighting.invalid">
        {{ 'barn.invalid.lighting' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-slide-toggle
      [hideIcon]="true"
      data-test="barn-item__hasUVLighting"
      color="primary"
      labelPosition="before"
      formControlName="hasUVLighting"
    >
      {{ 'barn.has-uv-lighting' | translate }}
    </mat-slide-toggle>
  </div>
</agr-form-dialog>
